if (!customElements.get('look-book')) {
  class LookBook extends HTMLElement {
    connectedCallback() {
      this.filters = this.querySelectorAll('[data-look-book-filter]');
      this.items = this.querySelectorAll('[data-look-book-item]');
      this.scroller = this.querySelector('.look-book__scroller');

      this.filters.forEach((btn) => {
        btn.addEventListener('click', () => this.applyFilter(btn));
      });

      // Selecting a card in the theme editor shows it, even if a filter hid it.
      this.addEventListener('shopify:block:select', (evt) => {
        if (evt.target.hidden && this.filters.length) this.applyFilter(this.filters[0]);
        evt.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    }

    /**
     * Shows only the looks whose style matches the chosen filter.
     * @param {HTMLButtonElement} activeBtn - The filter button that was chosen.
     */
    applyFilter(activeBtn) {
      const style = activeBtn.dataset.lookBookFilter;

      this.filters.forEach((btn) => {
        btn.setAttribute('aria-pressed', btn === activeBtn ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        item.hidden = style !== '' && item.dataset.style !== style;
      });

      this.scroller.scrollTo({ left: 0, behavior: 'auto' });
    }
  }

  customElements.define('look-book', LookBook);
}
